/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { DeleteTruckTypeMutation, DeleteTruckTypeMutationVariables } from "@models/graphql";

const defaultDeleteTruckTypeOptions: MutationHookOptions<DeleteTruckTypeMutation, DeleteTruckTypeMutationVariables> = {};

export const useDeleteTruckType = (options?: MutationHookOptions<DeleteTruckTypeMutation, DeleteTruckTypeMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<DeleteTruckTypeMutation, DeleteTruckTypeMutationVariables>(
        GraphQLDocuments.deleteTruckType
    );

    const deleteTruckType = async (variables: DeleteTruckTypeMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultDeleteTruckTypeOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        deleteTruckType
    };
};
